/**
 * GA4 name/param sanitizer. GA4 hard limits (not present in Amplitude):
 * event name <=40 chars, param key <=40, param value <=100, <=25 params/event,
 * names must match [A-Za-z0-9_] and start with a letter.
 */
import { PropertyValue } from './types'

export const GA_EVENT_NAME_MAX = 40
export const GA_PARAM_KEY_MAX = 40
export const GA_PARAM_VALUE_MAX = 100
export const GA_MAX_PARAMS = 25

const toSnake = (raw: string): string =>
    String(raw)
        .trim()
        .replace(/[^a-zA-Z0-9_]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '')
        .toLowerCase()

export const sanitizeEventName = (name: string): string => {
    const snake = toSnake(name)
    if (!snake) return 'unnamed_event'
    const safe = /^[a-z]/.test(snake) ? snake : `e_${snake}`
    return safe.slice(0, GA_EVENT_NAME_MAX)
}

const sanitizeKey = (key: string): string => toSnake(key).slice(0, GA_PARAM_KEY_MAX)

export const sanitizeParams = (props?: Record<string, PropertyValue | null | undefined>): Record<string, string | number | boolean> => {
    const out: Record<string, string | number | boolean> = {}
    if (!props) return out
    let count = 0
    for (const [rawKey, rawVal] of Object.entries(props)) {
        if (rawVal === undefined || rawVal === null) continue
        if (count >= GA_MAX_PARAMS) break
        const key = sanitizeKey(rawKey)
        if (!key) continue
        let val: string | number | boolean
        if (Array.isArray(rawVal)) val = rawVal.join(',').slice(0, GA_PARAM_VALUE_MAX)
        else if (typeof rawVal === 'string') val = rawVal.slice(0, GA_PARAM_VALUE_MAX)
        else val = rawVal
        out[key] = val
        count++
    }
    return out
}
